import CrudModule from "../components/CrudModule";

const STATUS = [
  { value: "new", label: "New" },
  { value: "contacted", label: "Contacted" },
  { value: "qualified", label: "Qualified" },
  { value: "won", label: "Won" },
  { value: "lost", label: "Lost" },
];

export default function LeadsPage() {
  return (
    <CrudModule
      testidPrefix="leads"
      resource="leads"
      overline="SALES PIPELINE"
      title="Leads & Follow-ups"
      subtitle="Capture inbound leads and draft AI follow-ups tuned to each lane."
      aiCategory="lead_followup"
      aiContextFields={["name", "company", "lane_needed", "estimated_value", "status", "notes"]}
      primaryField="company"
      initialForm={{ status: "new", estimated_value: 0 }}
      fields={[
        { key: "name", label: "Contact name", required: true },
        { key: "company", label: "Company", required: true },
        { key: "phone", label: "Phone" },
        { key: "email", label: "Email", type: "email" },
        { key: "lane_needed", label: "Lane needed", placeholder: "e.g. TX ↔ FL" },
        { key: "estimated_value", label: "Est. value ($)", type: "number" },
        { key: "status", label: "Status", type: "select", options: STATUS },
        { key: "notes", label: "Notes", type: "textarea", span: 2 },
      ]}
      columns={[
        { key: "company", label: "COMPANY" },
        { key: "name", label: "CONTACT" },
        { key: "lane_needed", label: "LANE" },
        { key: "estimated_value", label: "VALUE", render: (r) => <span className="font-mono">${Number(r.estimated_value || 0).toLocaleString()}</span> },
        { key: "status", label: "STATUS" },
      ]}
    />
  );
}
